<div class="row">
    <div class="col">
      Customer Type: {{data['icustomer_type_name']}}
    </div>
  
    <div class="col">
      Product: {{data['product_name']}}
    </div>
  </div>
  <div class="form-group">
    <label>Discount Price</label>
    <input type="number" class="form-control" #new_discount_price [value]="data['discount_price']">
  </div>
  <div class="row">
    <div class="col">
      <button style="margin-left: 40%;" mat-raised-button color="primary"
        (click)="updateDiscountPrice(new_discount_price.value)">Update</button>
    </div>
    <div class="col">
      <button style="margin-left: 40%;" mat-raised-button color="primary" (click)="closeComponent(null)">Close</button>
    </div>
  </div>